import { useMemo, useState, useEffect } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { REGEX_PHONE, REGEX_EMAIL } from "../../../../util/RegEx";
import { useAFBFunction } from "./useAFBFunction";
import { permissions } from "../../../../util/DataObject";
import { MenuItem, Select, TextField, Box, IconButton } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import moment from "moment";
moment.locale("es");

export const useAFBAdminDetail = (changeAlert: ChangeAlertCallbackType, action: string, config, onOpenDetail) => {
    const { handleSpacesGet, handleAdminList, handleCustomerList } = useAFBFunction(changeAlert);

    const [data, setData] = useState({});
    const [form, setForm] = useState({ admin: {email: "", phone: "", gname: "", lname: "", slname: ""}, company: [], account_acl: [], status: "" });
    const [companyData, setCompanyData] = useState(null);
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [spaces, setSpaces] = useState([]);
    const [admins, setAdmins] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [searchInside, setSearchInside] = useState({});
    const [searchOutside, setSearchOutside] = useState({});
    const [codeCom, setCodeCom] = useState("52");
    const [isValid, setIsValid] = useState(true);
    const [internalAction, setInternalAction] = useState("addCompany");

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalDocuments, setTotalDocuments] = useState(0);

    const saveData = async (data, roles?) => {
        setData(JSON.parse(JSON.stringify(data || {})));
        setCompanyData(JSON.parse(JSON.stringify(data["company"]?.slice(0, rowsPerPage) || {})));
        setTotalDocuments(data["company"]?.length || 0);
        roles && setRoles(JSON.parse(JSON.stringify(roles || [])));
        action === "edit" && saveEdit(data);
        action === "create" && newRegister();
    };

    const cleanData = async () => {
        setData({});
        setForm({ admin: {email: "", phone: "", gname: "", lname: "", slname: ""}, company: [], account_acl: [], status: "" });
        setCompanyData(null);
        setRoles([]);
        setSpaces([]);
        setAdmins([]);
        setCompanies([]);
        setSearchInside([]);
        setSearchOutside([]);
        setCodeCom("52");
        setIsValid(true);
        setTotalDocuments(0);
        setPage(0);
    };

    // FUNCTIONS ------------------------------------------------
    const newRegister = () => {
        let f = form;
        f["status"] = "enabled"
        setForm(JSON.parse(JSON.stringify(f)));
    };

    const saveEdit = (item) => {
        let f = form;
        let k = Object.keys(item);
        let code = codeCom;
        
        for (let i = 0; i < k.length; i++) {
            if (k[i] === "admin") {
                let input = Object.keys(item[k[i]])
                for (let v = 0; v < input.length; v++){
                    if (f["admin"].hasOwnProperty(input[v])) {
                        if (input[v] === "phone") {
                            code = item[k[i]][input[v]] && item[k[i]][input[v]].slice(1,3);
                            f["admin"][input[v]] = item[k[i]][input[v]].split(`+${code}`)[1];
                        } else {
                            f["admin"][input[v]] = item[k[i]][input[v]];
                        }          
                    }
                }
            } else if (k[i] === "uuid") {
                f[k[i]] = item[k[i]];
            } else {
                f.hasOwnProperty(k[i]) && (f[k[i]] = item[k[i]]);
            }
        }

        setCodeCom(code);
        setForm(JSON.parse(JSON.stringify(f)));
    };

    const onHandleSearch = ({value, type}) => {
        setSearchInside({value: value, type: type});
        setLoading(true);

        const orderData = action === "detail" ? data["company"] : form["company"];

        let find = [];
        if(value && type){
            switch (type) {
                case "company_name":
                    find = orderData.filter((i) => i.name.toLowerCase()?.indexOf(value.toLowerCase()) > -1);
                    break;
                case "uuid":
                    find = orderData.filter((i) => i.uuid === value);
                    break;
                default:
                    break;
            }
            setTotalDocuments(find.length || 0);
            setCompanyData(JSON.parse(JSON.stringify(find)));
        } else {
            setTotalDocuments(orderData.length || 0);
            changePage(null, 0, rowsPerPage, action === "detail" ? data["company"] : form["company"]);
        }

        setPage(0);
        setLoading(false);
    };

    const onHandleOrder = (item, key) => {
        setLoading(true);
        const orderData = action === "detail" ? data["company"] : form["company"];
        let order = orderData.slice().sort((a, b) => {
            switch (key) {
                case "name_a":
                    return a.name?.localeCompare(b.name);
                case "name_z":
                    return b.name?.localeCompare(a.name);
                default:
                    return 0;
            }
        });
        action === "detail" ?
        setData(JSON.parse(JSON.stringify({
            ...data,
            company: order
        }))) :
        setForm(JSON.parse(JSON.stringify({
            ...form,
            company: order
        })));
        changePage(null, 0, rowsPerPage, order);
        setLoading(false);
    };

    const onHandleChange = (field1, field2, field3, formData = form, e) => {
        let f = formData;

        switch (field1) {
            case "admin":
                f[field1][field2] = e.target.value;
                break;
            case "phone_code":
                setCodeCom(e.target.value);
                break;
            case "company":
                if (field2 === "rol") {
                    f[field1].map((r, index) => {
                        if(r.uuid === field3){
                            f[field1][index][field2] = [{uuid : e.target.value}];
                        }
                        return r;
                    })
                    setCompanyData(JSON.parse(JSON.stringify(f[field1].slice(0, rowsPerPage))));
                }
                break;
            case "account_acl":
                const addSpace = () => {
                    f[field1].splice(field3, 0,{
                        space_uuid: field2,
                        permission: e.target.value,
                    });
                };

                if (f[field1].length > 0) {
                    f[field1]?.map((i, index) => {
                        if (i["space_uuid"] === field2) {
                            f[field1][index]["permission"] = e.target.value;
                        }
                        if (!Object.values(f[field1]?.map((i) => { return i.space_uuid })).includes(field2)) {
                            addSpace();
                        }
                        return i;
                    });
                } else {       
                    return addSpace();
                }

                let cleanData = cleanSpaces(spaces, f["account_acl"]);
                setSpaces(JSON.parse(JSON.stringify(cleanData)));
                break;
        }
        onVerifyAdmin(f);
        setForm(JSON.parse(JSON.stringify(f)));
    };

    const onAddCompany = async (item) => {
        let f = form;

        let newCompany = f["company"];
        let validate = newCompany.filter((a) => a.name === item.corporate_name).length === 0;
        if (validate) {
            let spacesGet = await onGetSpaces(item.uuid);
            if(spacesGet){
                newCompany.unshift({
                    name: item.corporate_name,
                    uuid: item.uuid,
                });
                f["company"] = newCompany;

                setForm(JSON.parse(JSON.stringify(f)));
                setTotalDocuments(newCompany.length);
                setCompanyData(JSON.parse(JSON.stringify(newCompany.slice(0, rowsPerPage))));
                changeAlert(true, "success", "La empresa se agregó con éxito.");
            } else {
                changeAlert(true, "error", "La empresa indicada no posee Espacios asignados y no puede ser agregada.");
            }
        } else {
            changeAlert(true, "error", "La empresa indicada ya se encuentra en el listado.");
        }
    };

    const onDeleteCompany = async (row) => {
        let f = form;
        
        const index_1 = f["company"].findIndex(item => item.uuid === row.uuid);
        if (index_1 !== -1) {
            f["company"][index_1]["action"] = "delete";
        }
        
        const getCleanspaces = await onGetSpaces(row.uuid);
        if (getCleanspaces) {
            const valuesToRemove = new Set(getCleanspaces?.map(item => item.uuid));
            f["account_acl"] = f["account_acl"].filter(item => !valuesToRemove.has(item["space_uuid"]));
        }

        setSpaces(JSON.parse(JSON.stringify([])));
        setForm(JSON.parse(JSON.stringify(f)));
        setTotalDocuments(f["company"].length);
        setCompanyData(JSON.parse(JSON.stringify(f["company"].slice(0, rowsPerPage))));
        changePage(null, 0, rowsPerPage, f["company"].slice(0, rowsPerPage));
        onVerifyAdmin(f);
    };

    const onDeleteSpace = async (row) => {
        let f = form;
        let s = spaces;

        f["account_acl"] = f["account_acl"].filter(item => item.space_uuid !== row.uuid);
        s = s.filter(item => item.uuid === row.uuid ? delete item["permission"] : item);

        setSpaces(JSON.parse(JSON.stringify(s)));
        setForm(JSON.parse(JSON.stringify(f)));
    };

    const onAddAdmin = async (item) => {
        setLoading(true);
        let f = form;

        if (f["uuid"] !== item["uuid"]) {
            let filteredArray = [];
            const filterAndMergeArrays = (array1, array2, prop) => {
                const idsToRemove = new Set(array2.map(item => item[prop]));
                filteredArray = array1.filter(item => !idsToRemove.has(item[prop]));
                return array2 = [...filteredArray, ...array2];
            };

            f["account_acl"] = await filterAndMergeArrays(item["account_acl"], f["account_acl"], "space_uuid");
            f["company"] = await filterAndMergeArrays(item["company"], f["company"], "uuid");
            if (filteredArray.length === 0) {
                changeAlert(true, "error", "Las cuentas asociadas al agente ya se encuentran incluídas.");
                return setLoading(false);
            }

            setForm(JSON.parse(JSON.stringify(f)));
            setTotalDocuments(f["company"].length);
            setCompanyData(JSON.parse(JSON.stringify(f["company"].slice(0, rowsPerPage))));
            changeAlert(true, "success", "Las empresas, cuentas y permisos fueron copiados con éxito.");
        } else {
            changeAlert(true, "error", "Está intentando copiar al mismo agente, por favor verifique e intente nuevamenete.");
        }
        onVerifyAdmin(f);
        setLoading(false);
    };

    const onShowInfo = (customer) => {
        return onGetSpaces(customer.uuid)
    };

    const cleanSpaces = (spaces_list, data_spaces) => {
        let cleanData = spaces_list.map((a) => {
            data_spaces?.map((b) => b.space_uuid === a.uuid && (a["permission"] = b["permission"]))
            return a;
        });
        return cleanData;
    };

    const onVerifyAdmin = (f) => {
        const test = Object.entries(f["admin"]).every(([key, value]) => {
            if (key === "slname") return true;
            if (value === null || value === undefined || value === "") return false;
            if (key === "email") return REGEX_EMAIL.test(String(value));
            if (key === "phone") return REGEX_PHONE.test(String(`+${codeCom}${value}`));
            
            return true;
        });
        
        return test && f["company"].length > 0 ? setIsValid(false) : setIsValid(true);
    };

    const onSelectForm = (isExpanded) => {
        setInternalAction(isExpanded);
    };

    // SERVICE REQUEST ------------------------------------------------

    const onGetSpaces = async (uuid) => {
        setLoading(true);
        let resp = await handleSpacesGet(uuid);
        if (resp) {
            let cleanData = cleanSpaces(resp, action !== "detail" && form["account_acl"] ? form["account_acl"] : data["account_acl"]);
            setSpaces(JSON.parse(JSON.stringify(cleanData)));
            setLoading(false);
            return cleanData.length > 0 && cleanData;
        } else {
            setLoading(false);
        }
    };

    const onGetAdmin = async ({value, type}) => {
        if (value) {
            setLoading(true);
            setSearchOutside({value: value, type: type});
            
            let payload = {
                filter: { email: value },
                offset: page,
                limit: rowsPerPage,
            };
    
            let resp = await handleAdminList(payload);
            resp ? setAdmins(JSON.parse(JSON.stringify(resp["content"]["users"] || []))) : setAdmins([]);
            setLoading(false);
        } else {
            changeAlert(true, "error", "La búsqueda no puede estar vacía, por favor indique un valor.");
        }
    };

    const onGetCompany = async ({value, type}) => {
        if (value) {
            setLoading(true);
            setSearchOutside({value: value, type: type});
            
            let payload = {
                customer: { keyword: value },
                filters: { 
                    results_per_page: 20, 
                    page_number: 1, 
                    search_type: type 
                }
            };
    
            let resp = await handleCustomerList(payload);
            resp ? setCompanies(JSON.parse(JSON.stringify(resp["data"]["content"] || []))) : setCompanies([]);
            setLoading(false);
        } else {
            changeAlert(true, "error", "La búsqueda no puede estar vacía, por favor indique un valor.");
        }
    };

    // PAGINATION ------------------------------------------------

    const changePage = (event, page, rows = rowsPerPage, list) => {
        list = !list ? (action === "detail" ? data["company"] : form["company"]) : list
        setPage(page);
        setCompanyData(JSON.parse(JSON.stringify(list.slice(page === 0 ? 0 : (rows * page) + 1, rows * (page + 1)))));
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setRowsPerPage(JSON.parse(JSON.stringify(event.target.value)));
        changePage(null, 0, parseInt(event.target.value, 10), action === "detail" ? data["company"] : form["company"]);
    };

    // DATATABLE´S ------------------------------------------------
    const getType = (rol) => {
        const result = roles.filter((r) => r.uuid === rol[0].uuid);
        return result.length > 0 ? result[0]["name"] : "Por asignar"
    };

    const columnsCompany = useMemo(() => {
        const columns = [
            { cell: (row) => {
                return <>
                    <b>{row.name} -</b><p>{(row.rol ? getType(row.rol) : "Por asignar")}</p>
                </>
            }, wrap: true, sortable: true}
        ];

        return columns;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [roles]);

    const columnsCompanyEdit = useMemo(() => {
        const columns = [
            { cell: (row) => {
                return <Box style={{display: "flex", placeItems: "center"}}>
                <b style={{marginRight: 10, width: "100%"}}>{row.name} -</b>
                <Select value={(row["rol"] && row["rol"].length > 0) ? row["rol"][0]["uuid"] : -1} disabled={row["action"] && row["action"] === "delete" ? true : false} onChange={onHandleChange.bind(this, "company", "rol", row.uuid, form)} color="secondary" MenuProps={{ style: { zIndex: 35001 } }} variant="standard">
                    <MenuItem value={-1} disabled>Seleccione</MenuItem>
                    {roles.map((i) => (
                        <MenuItem key={`rol-${i.uuid}`} value={i.uuid}>
                            {i.name}
                        </MenuItem>
                    ))}
                </Select>
                </Box>           
            }, sortable: true},
            { cell: (row) => {
                return row["action"] && row["action"] === "delete" ? "Se eliminará" : <IconButton onClick={onDeleteCompany.bind(this, row)} ><DeleteIcon color="primary"/></IconButton>
            }, width: "10%", sortable: true, center: true}
        ];

        return columns;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [roles, companies, form]);

    const columnsAccount = useMemo(() => {
        const columns = [
            { selector: (row) => row.name, name: "Cuenta", width:"17%", wrap: true, sortable: true },
            { selector: (row) => row.accountNumber, name: "Número de cuenta", width:"17%", wrap: true, sortable: true },
            { selector: (row) => row["permission"] ? permissions.filter((i) => i.key === row["permission"])[0].label : "Por definir", name: "Tipo de permiso", width: "17%", wrap: true, sortable: true, center: true },
        ];

        return columns;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const columnsAccountEdit = useMemo(() => {
        const columns = [
            { cell: (row) => {
                    return <TextField variant="standard" value={row.name} disabled />
                }, name: `Cuenta`, width:"17%", sortable: true },
            { cell: (row) => {
                    return <TextField variant="standard" value={row.accountNumber} disabled />
                }, name: `Número de cuenta`, width:"17%", sortable: true },
            { cell: (row) => {
                    return <Select value={row["permission"] || -1} onChange={onHandleChange.bind(this, "account_acl", row.uuid, null, form)} color="secondary" MenuProps={{ style: { zIndex: 35001 } }} variant="standard" fullWidth>
                        <MenuItem value={-1} disabled>Seleccione</MenuItem>
                        {permissions.map((i) => (
                            <MenuItem key={`validation-${i.key}`} value={i.key}>
                                {i.label}
                            </MenuItem>
                        ))}
                    </Select>
            }, name: "Tipo de permiso", wrap: true, sortable: true, width: "17%"},
            { cell: (row) => {
                return <IconButton onClick={onDeleteSpace.bind(this, row)} disabled={!row["permission"]} ><DeleteIcon color={!row["permission"] ? "inherit" : "primary"}/></IconButton>
            }, width: "5%", sortable: true}
        ];

        return columns;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [spaces, form]);

    useEffect(() => {
        !action && cleanData();
    }, [action]);

    return {
        data,
        form,
        spaces,
        admins,
        codeCom,
        companies,
        isValid,
        loading,
        searchInside,
        searchOutside,
        companyData,
        columnsCompany,
        columnsCompanyEdit,
        columnsAccount,
        columnsAccountEdit,
        internalAction,
        pagination: { page, rowsPerPage, totalDocuments },
        saveData,
        onShowInfo,
        onGetAdmin,
        onAddAdmin,
        onGetCompany,
        onAddCompany,
        onHandleSearch,
        onHandleChange,
        onHandleOrder,
        cleanData,
        onSelectForm,
        changePage,
        handleChangeRowsPerPage,
    };
};
